import { render, staticRenderFns } from "./VideoRoom2.vue?vue&type=template&id=ec5572de"
import script from "./VideoRoom2.vue?vue&type=script&lang=js"
export * from "./VideoRoom2.vue?vue&type=script&lang=js"
import style0 from "./VideoRoom2.vue?vue&type=style&index=0&id=ec5572de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports